// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__ihTXx","title":"card_title__2oxM4","inActive":"card_inActive__14JkP"};